export default {"src":"/_next/static/image/public/images/ic_order_failed_records.2e49bc78e79ffd3debc2461cf6fe8077.svg","height":135,"width":122};